// extracted by mini-css-extract-plugin
export default {"mochi_cheer_component":"modal_mochi_cheer_component__ym7Lc","inputModal":"modal_inputModal__1G20f"};